import React from "react";
import Dropzone from "react-dropzone";
import Image from "../../assets/images/png/upload.webp";

const InputFileGroup = ({
  onDrop,
  accept,
  preview,
  onDeleteClick,
  marginBottom,
  maxSize,
}) => {
  return (
    <>
      <div
        className={`${
          marginBottom || "mb-6"
        } dropzone dropzone-default text-center bg-gray-30 rounded-xl border  border-dashed border-gray h-32 w-full flex items-center justify-center`}
        id="kt_dropzone_1"
      >
        {preview ? (
          <div className="relative lg:ml-4">
            <div className="flex flex-wrap items-center justify-center md:justify-start">
              <div
                style={{
                  backgroundImage: `url(${preview})`,
                  backgroundPosition: "center",
                }}
                className="relative rounded-xl bg-cover h-28 w-28 md:mr-4"
              />
            </div>
            <button
              className="absolute top-2 right-6 h-6 w-6 bg-white rounded-full hover:bg-red-600 hover:text-white transition-all ease-in-out shadow-xl text-temp-secondary"
              onClick={onDeleteClick}
            >
              x
            </button>
          </div>
        ) : (
          <Dropzone
            onDrop={onDrop}
            accept={accept}
            maxSize={maxSize || 5097152}
          >
            {({ getRootProps, getInputProps }) => (
              <div className="dropzone-msg dz-message">
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <div className="relative">
                    <div className="w-full mx-auto text-center">
                      <img
                        src={Image}
                        alt="Upload"
                        className="w-10 h-10 mx-auto mb-2"
                      />

                      <button className="text-default bg-transparent text-sm-15 focus:outline-none">
                        Add image
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Dropzone>
        )}
      </div>
    </>
  );
};

export default InputFileGroup;
